import { faCopy, faSave } from "@fortawesome/free-solid-svg-icons";
import React, { type FC, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { v4 as uuid } from "uuid";
import { useApiCall } from "../api/api";
import { Company, type Exam, Project } from "../api/dto";
import { SectionHeader } from "../components/content/SectionHeader";
import { Input } from "../components/form/Input";
import { Select } from "../components/form/Select";
import { Toggle } from "../components/form/Toggle";
import { ModalFooter } from "../components/layout/ModalProvider";
import { Paragraph } from "../components/Paragraph";
import { useRefresh } from "../components/RefreshController";

export const RegenResultsModal: FC<{ exam: Exam }> = (props) => {
  const { regenCertificatesOnExam } = useApiCall();
  const reload = useRefresh();

  const confirm = async () => {
    await regenCertificatesOnExam(props.exam.id);
    reload();
  };

  return (
    <>
      <SectionHeader>Opnieuw certificaten verwerken</SectionHeader>
      <Paragraph>
        Hiermee worden alle resultaten van de examens opnieuw berekent. Hiermee worden nieuwe
        certificaten gegenereerd, en wordt de data naar eventuele koppelingen opgestuurd.
      </Paragraph>
      <ModalFooter icon={faSave} text={"Opnieuw verwerken"} onSubmit={confirm} />
    </>
  );
};
